import { Component, Input, OnInit } from '@angular/core';
import { IDeviceContract } from '@nx-fe/services';

@Component({
  selector: 'app-card-device-status',
  templateUrl: './card-device-status.component.html',
  styleUrls: ['./card-device-status.component.scss'],
})
export class CardDeviceStatusComponent implements OnInit {
  @Input() device: IDeviceContract;

  constructor() {}

  ngOnInit() {}
}
